import type {Duration} from '../util/Duration';
import type {SimpleBanner} from '../variant/SimpleBanner';

import {LoggingTrigger} from './LoggingTrigger';

export class RefreshTriggerBase extends LoggingTrigger {
    banner: SimpleBanner | null = null;

    attach(banner: SimpleBanner) {
        this.banner = banner;
    }

    refresh() {
        this.banner?.requestBanner();
    }

    getDurationSinceLastRefresh(): Duration {
        return this.banner?.getDurationSinceLastRefresh()!;
    }
}
